import hubRetina from 'marketing-website/media/images/pages/features/collaboration/hub@2x.jpg';
import directoryRetina from 'marketing-website/media/images/pages/features/collaboration/directory@2x.jpg';
import directoryFallbackRetina from 'marketing-website/media/images/pages/features/collaboration/directoryFallback@2x.jpg';
import personRowRetina from 'marketing-website/media/images/pages/features/collaboration/personRow@2x.jpg';
import marketingTeamRetina from 'marketing-website/media/images/pages/features/collaboration/marketingTeam@2x.jpg';
import teamsFallbackRetina from 'marketing-website/media/images/pages/features/collaboration/teamsFallback@2x.jpg';
import directoryTeamsRetina from 'marketing-website/media/images/pages/features/collaboration/directoryTeams@2x.jpg';
import feedRetina from 'marketing-website/media/images/pages/features/collaboration/feed@2x.jpg';
import manageTeamRetina from 'marketing-website/media/images/pages/features/collaboration/manageTeam@2x.jpg';
import sharedFolderRetina from 'marketing-website/media/images/pages/features/collaboration/sharedFolder@2x.jpg';

const assets = {
  hub: {
    alt: 'Collaboration',
    src: hubRetina,
  },
  directory: {
    alt: 'Collaboration',
    src: directoryRetina,
  },
  directoryFallback: {
    alt: 'Collaboration',
    src: directoryFallbackRetina,
  },
  personRow: {
    alt: 'Collaboration',
    src: personRowRetina,
  },
  marketingTeam: {
    alt: 'Collaboration',
    src: marketingTeamRetina,
  },
  teamsFallback: {
    alt: 'Collaboration',
    src: teamsFallbackRetina,
  },
  directoryTeams: {
    alt: 'Collaboration',
    src: directoryTeamsRetina,
  },
  feed: {
    alt: 'Collaboration',
    src: feedRetina,
  },
  manageTeam: {
    alt: 'Collaboration',
    src: manageTeamRetina,
  },
  sharedFolder: {
    alt: 'Collaboration',
    src: sharedFolderRetina,
  },
};

export default assets;



// WEBPACK FOOTER //
// ./src/configs/pages/features/collaboration/assets.js